import React from 'react';
import './Channel.css';

const Channel: React.FC = () => {
    return (
        <section className="channel">
            <div className="channel-content">
                <h2 className="channel-title">Nosso Canal</h2>
                <div className="video-container">
                    <iframe
                        className="channel-video"
                        src="https://www.youtube.com/embed/rNYbL9m_aBQ"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    ></iframe>
                </div>
            </div>
        </section>
    );
}

export default Channel;